export default "__VITE_ASSET__PjWcPuGS__"